var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"controls"},[_c('button',{on:{"click":_vm.randomizeColors}},[_vm._v("randomize")]),_c('button',{attrs:{"disabled":_vm.colorDisplay === 2},on:{"click":_vm.removeColor}},[_vm._v("-")]),_c('button',{attrs:{"disabled":_vm.colorDisplay === 5},on:{"click":_vm.addColor}},[_vm._v("+")])])
}
var staticRenderFns = []

export { render, staticRenderFns }